module.exports = __webpack_public_path__ + "img/fb07.90cf66d0.jpg";